import React, { useContext, useState } from "react";
import FuncionesContext from "../../../context/FuncionesContext";
import TextFieldEditable from "../../../components/TextFieldEditable";

import { validarRegex } from "../../../context/FuncionesContext";

const InputTextEditable = ({
  data,
  cab,
  campokey,
  id_elemento,
  updateState,
}) => {
  const { superSubmit } = useContext(FuncionesContext);

  const [value, setValue] = useState(data[campokey]);

  const [lastValue, setLastvalue] = useState(data[campokey]);
  const [updateId, setUpdateId] = useState(data[cab.update_id_alias]);

  const [error, setError] = useState(false);

  const handleCancelar = () => {
    setValue(data[campokey]);
    const inputElement = document.getElementById(id_elemento + "_field");
    inputElement.value = data[campokey];
    // console.log(data[campokey], inputElement);
  };

  const handleOnBlur = (e) => {
    const valor = e.target.value;
    if (valor === lastValue || (valor === "" && lastValue === null)) {
      return;
    }
    if (valor === null || lastValue?.toString() === valor.toString().trim())
      return;
    if (validarRegex(e.target.value, cab.validacion_regex, cab)) {
      setError(false);
      return;
    }
    handleCancelar();
    //  setError(true);
    return;
  };

  const handleGuardar = async (e) => {
    const valor = e.target.value;
    if (valor === lastValue || (valor === "" && lastValue === null)) {
      return;
    }
    if (valor === null || lastValue?.toString() === valor.toString().trim())
      return;

    const { id_a } = cab;

    superSubmit({ valor, id_a, update_id: updateId, handleCancelar, cab, data })
      .then((result) => {
        setLastvalue(() => valor);
        updateState(campokey, valor);
        if (!updateId) {
          updateState(cab.update_id_alias, result.data.registro.id);
          setUpdateId(result.data.registro.id);
        }
        return result;
      })
      .catch((err) => {
        console.log("Cancelado ", err);
        handleCancelar();
      });
  };

  const align = (() => {
    let clas = "align-left";

    if (cab.align?.trim() === "center") {
      clas = "align-center";
    }
    if (cab.align?.trim() === "right") {
      clas = "align-right";
    }

    return clas;
  })();

  const disabled = (() => {
    if (data[cab.id_a + "_disabled"]) {
      return data[cab.id_a + "_disabled"] === "s";
    }
    if (cab.disabled) {
      return cab.disabled === "s";
    }
    return false;
  })();

  return (
    <div id={id_elemento} className={`tarjeta_grid_item_label_item ${cab.className}`}>
      <TextFieldEditable
        disabled={disabled}
        value={value}
        error={error}
        helperText={error ? cab.helperText : ""}
        lastValue={lastValue}
        setValue={setValue}
        onEnter={handleGuardar}
        onBlur={handleOnBlur}
        maxCaracteres={parseInt(cab.maximo_caracteres ?? 1000)}
        idInput={id_elemento + "_field"}
        className={`_textFieldEditable ${align}`}
        inputClassName={cab.input_class_caja ?? ""}
      />
    </div>
  );
};

export default InputTextEditable;
